<template>
  <div class="print-personal-account">
    <div class="print-personal-account__container">
      <div class="print-personal-account__employee">Расчётный лист {{ employeeName }}</div>
      <div v-if="period" class="print-personal-account__period">
        {{ period }}
      </div>
      <operations-table class="print-personal-account__table" :operations="operations" :columns="columns" :print="true" />
      <div class="print-personal-account__total">
        ИТОГО К ВЫПЛАТЕ:
        <span class="total">
          {{
            total.toLocaleString("ru-RU", {
              style: "currency",
              currency: "RUB",
            })
          }}
        </span>
      </div>
      <div class="print-personal-account__sign">({{ employeeName }})</div>
    </div>
  </div>
</template>

<script>
import { AccountOperation } from "@/entities/models/account-operation";
import OperationsTable from "./components/account-history-table/table-new";

export default {
  components: { OperationsTable },
  data() {
    return {
      dates: [],
      operations: [],
      employeeName: "",
      period: "",
      total: 0,
      columns: [],
      columnSequence: ["date_user", "amount_before", "added_amount", "withdraw_amount", "amount_after", "transaction_type"],
    };
  },
  created() {
    const { workerId, periodStart, periodEnd, deleted } = this.$route.query;

    if (periodStart && periodEnd) this.period = `${periodStart}-${periodEnd}`;
  console.log('dfhdfh');

    Promise.all([
      this.$store.dispatch("personalEmployee/getUserInfo", workerId).then((res) => {
        this.employeeName = res.response.name;
        document.title = `Расчётный лист ${this.employeeName}`;
      }),
      this.$store.dispatch("personalEmployee/getColumnsTransactionsPersonalAccount", deleted).then(res => {
        const columns = res.columns;

        this.columnSequence.forEach(columnId => {
          columns.forEach(column => {
            if (columnId === column.code) {
              this.columns.push({
                id: column.code,
                label: column.name,
                fullName: column.name,
                type: column.data_type,
                level: column.level,
                isCategory: column.is_category,
                disabled: column.disabled,
                isSorted: false,
              })
            }
          })
        })
      }),
      this.$store
        .dispatch("personalEmployee/getListTransactionsPersonalAccountForPrint", this.$route.query)
        .then((res) => {
          this.operations = res.map((record) => new AccountOperation(record));
          this.total = this.operations[0].amount_after.value;
          // this.dates = groupOperationsByDate(operations, "print");
        }),
    ]).then(() => {
      this.$nextTick(() => {
        //this.print();
      });
    });
  },
  methods: {
    print() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
  },
};
</script>
<style lang="scss">
html.print {
  &,
  body {
    overflow: auto !important;
  }
  .app {
    overflow: auto;
    height: auto;
    width: auto;
  }
}

.print-personal-account {
  padding: 40px;
  &__container {
    width: 800px;
    padding-bottom: 40px;
  }
  .account-history {
    width: 680px;

    &__author {
      display: none;
    }
    &__reason {
      display: none;
    }
    .operations-date {
      &__opener {
        visibility: hidden;
      }
    }
    .positive-number,
    .negative-number {
      color: #212529;
    }
  }
  &__employee {
    font-size: 22px;
    font-weight: 500;
  }
  &__period {
    font-size: 15px;
    font-weight: 500;
    margin-top: 6px;
  }
  &__table {
    margin-top: 24px;
  }
  &__total {
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 13px;
    height: 39px;
    border: 1px solid #dfe4ef;
    border-bottom-width: 2px;
    padding: 5px 10px;
    page-break-after: avoid;

    .total {
      font-size: 15px;
      font-weight: bold;
      margin-left: 36px;
    }
  }
  &__sign {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    border-bottom: 1px solid #dfe4ef;
    padding-bottom: 10px;
    page-break-before: avoid;
  }
}
</style>
